/**
 * 建筑信息编辑
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Cascader } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import OrgSelect from '../../ui/OrgSelect';

import { area } from '../../../util/area.js';

const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    "org": true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}, {
    "text": "建筑编码",
    "field": "buildingCode",
    rules: [
        { required: true, message: '建筑编码不能为空!' },
        { max: 16, message: '建筑编码不能超过16个字符！' },
        validator.lineEnNum
    ]
}, {
    "text": "建筑名称",
    "field": "buildingName",
    rules: [
        { required: true, message: '建筑名称不能为空!' },
        { max: 32, message: '建筑编码不能超过32个字符！' },
    ]
}, {
    "text": "省/市/区县",
    "field": "address",
    "area": true,
    rules: [
        { required: true, message: '省/市/区县不能为空!' },
    ]
}, {
    "text": "地址",
    "field": "road",
    rules: [
        { required: true, message: '地址不能为空!' },
        { max: 32, message: '建筑编码不能超过32个字符！' },
    ]
}, {
    "text": "顺序",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '顺序不能为空!' },
    ]
}];


class BuildingEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            
            let address = values["address"];
            values["province"] = address[0];
            values["city"] = address[1];
            values["zone"] = address[2];
            delete values["address"];
            http.post({
                url: '/building/saveBuilding',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (fields) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < fields.length; i++) {
            let item = fields[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.number ?
                                <InputNumber precision={0} min={1} max={99} style={{ width: '100%' }} />
                                : item.org ? <OrgSelect orgType={2} />
                                    : item.area ?
                                        <Cascader options={area} placeholder="请选择地址" fieldNames={{ label: 'label', value: 'label', children: 'children' }} />
                                        : <Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                width={500}
                title="建筑信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields(); }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const BuildingEdit = Form.create()(BuildingEditForm);

export default BuildingEdit;